import { render, staticRenderFns } from "./AuthFormTabs.vue?vue&type=template&id=545dca0c&scoped=true&"
import script from "./AuthFormTabs.vue?vue&type=script&lang=js&"
export * from "./AuthFormTabs.vue?vue&type=script&lang=js&"
import style0 from "./AuthFormTabs.vue?vue&type=style&index=0&id=545dca0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545dca0c",
  null
  
)

export default component.exports